/**
 * Daily-streak counter — a big flame + number showing "how many days in a
 * row". Used as a hero card on the My Stickers screen (`variant="card"`,
 * full-width) and in a compact form inside the What's New modal
 * (`variant="compact"`).
 *
 * Zero is shown gently (muted flame, "Start a streak!") rather than hidden,
 * so it never reads as a scolding and the layout stays put.
 */
import "./StreakCounter.css";

export function StreakCounter({
  days,
  variant = "card",
}: {
  days: number;
  variant?: "card" | "compact";
}) {
  const started = days >= 1;
  return (
    <div
      className={`streak-counter streak-counter--${variant}${started ? "" : " streak-counter--zero"}`}
      role="img"
      aria-label={started ? `${days} day streak` : "No streak yet — do today's spellings to start one"}
    >
      <span className="streak-counter__flame" aria-hidden="true">
        🔥
      </span>
      <div className="streak-counter__text">
        <span className="streak-counter__number">{days}</span>
        <span className="streak-counter__label">{started ? "day streak" : "Start a streak!"}</span>
      </div>
    </div>
  );
}
